import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics';

/**
 * Sends a page_view on every client-side navigation.
 *
 * The app is a SPA, so GA4's automatic page_view (which fires once on script
 * load) would only ever count the entry page — GA4 is configured with
 * send_page_view: false and fed from here instead.
 *
 * The title is read one frame late because react-helmet-async writes
 * document.title in its own effect, which would otherwise still hold the
 * previous route's title at this point.
 */
export function usePageViews() {
  const { pathname } = useLocation();

  useEffect(() => {
    const id = requestAnimationFrame(() => trackPageView(pathname));
    return () => cancelAnimationFrame(id);
  }, [pathname]);
}
